import type { AutoWithdrawalNetworkCode } from '@shared/api/contracts';

export const normalizeAddressForCompare = (address: string): string => address.trim();

export const areAutoWithdrawalAddressesEqual = (
  networkCode: AutoWithdrawalNetworkCode | string,
  left: string,
  right: string,
): boolean => {
  const leftTrimmed = normalizeAddressForCompare(left);
  const rightTrimmed = normalizeAddressForCompare(right);
  const network = networkCode.toUpperCase();

  if (network === 'ERC20' || network === 'BEP20') {
    return leftTrimmed.toLowerCase() === rightTrimmed.toLowerCase();
  }

  return leftTrimmed === rightTrimmed;
};

export const hasAddressChangedFromPersisted = (
  networkCode: AutoWithdrawalNetworkCode,
  currentAddress: string,
  persistedAddress: string | null,
): boolean => {
  if (!persistedAddress?.trim()) return false;
  return !areAutoWithdrawalAddressesEqual(networkCode, currentAddress, persistedAddress);
};
